import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full max-w-md space-y-6 rounded-2xl border border-gray-200 bg-white p-8 text-left shadow-lg sm:text-center"
}
const _hoisted_2 = { class: "space-y-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-lg font-semibold leading-snug text-red-600"
}
const _hoisted_4 = { class: "whitespace-pre-line text-base leading-relaxed text-gray-600" }
const _hoisted_5 = { class: "text-sm text-gray-500" }
const _hoisted_6 = {
  key: 1,
  class: "flex w-full max-w-md flex-col items-center"
}
const _hoisted_7 = {
  key: 0,
  class: "mb-6 flex h-20 max-h-[80px] w-full shrink-0 items-center justify-center px-2"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "w-full rounded-2xl border border-gray-200 bg-white p-8 shadow-lg" }
const _hoisted_10 = { class: "mt-3 text-sm leading-relaxed text-gray-600" }
const _hoisted_11 = { class: "mt-4 break-all rounded-lg border border-gray-200 bg-gray-50 px-3 py-3 font-mono text-sm text-gray-900" }
const _hoisted_12 = { class: "mt-6 flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-end" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarLoader = _resolveComponent("BarLoader")!
  const _component_CognitoBrandedShell = _resolveComponent("CognitoBrandedShell")!

  return (_openBlock(), _createBlock(_component_CognitoBrandedShell, null, {
    default: _withCtx(() => [
      (_ctx.errorDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.errorHeading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorHeading), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errorDetail), 1)
            ]),
            _createElementVNode("p", _hoisted_5, " Returning to the home screen in " + _toDisplayString(_ctx.redirectSecondsRemaining) + " seconds… ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "w-full rounded-lg bg-[#9489F5] px-4 py-3 text-sm font-medium text-white shadow-sm hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#9489F5] focus:ring-offset-2 focus:ring-offset-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToHome && _ctx.returnToHome(...args)))
            }, " Return to home ")
          ]))
        : (_ctx.invitedEmailPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.showInviteCompanyLogo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _ctx.inviteCompanyLogoUrl || undefined,
                      alt: "",
                      class: "max-h-[80px] max-w-full object-contain",
                      onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInviteCompanyLogoError && _ctx.onInviteCompanyLogoError(...args)))
                    }, null, 40, _hoisted_8)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, " Accept your invitation ", -1)),
                _createElementVNode("p", _hoisted_10, [
                  (_ctx.inviteRedirectMode === 'signup')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" You've been invited to join. To accept, continue to sign up using the email address below. ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" You've been invited. Sign in using the email address below. ")
                      ], 64))
                ]),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.invitedEmailPreview), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "order-2 inline-flex h-[50px] min-w-[30%] items-center justify-center rounded-md border border-gray-300 bg-white px-3 text-base font-medium leading-6 text-gray-700 antialiased hover:bg-gray-50 sm:order-1",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyInvitedEmail && _ctx.copyInvitedEmail(...args)))
                  }, _toDisplayString(_ctx.copyEmailLabel), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["order-1 inline-flex h-[50px] min-w-[30%] items-center justify-center rounded-md px-3 text-base font-medium leading-6 antialiased focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white sm:order-2", 
              _ctx.hasCopiedEmail
                ? 'cursor-pointer border border-gray-200 bg-[rgb(124,58,237)] text-white hover:bg-[rgb(109,40,217)] focus:ring-[rgb(124,58,237)]'
                : 'cursor-not-allowed border border-gray-200 bg-[rgb(124,58,237)]/12 text-[rgb(124,58,237)]/50'
            ]),
                    disabled: !_ctx.hasCopiedEmail,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.continueToHostedAuth && _ctx.continueToHostedAuth(...args)))
                  }, _toDisplayString(_ctx.inviteRedirectMode === "signin" ? "Sign in" : "Accept invite"), 11, _hoisted_13)
                ])
              ])
            ]))
          : (_openBlock(), _createBlock(_component_BarLoader, {
              key: 2,
              variant: "spinner",
              theme: "light",
              contained: "",
              message: "Checking your invitation…"
            }))
    ]),
    _: 1
  }))
}